import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "upgrade-module" }
const _hoisted_2 = { class: "upgrade-module-environment-title" }
const _hoisted_3 = { class: "upgrade-module-environment-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "upgrade-module-version-item-slide" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "upgrade-module-version-label" }, " 版本号 ", -1)
const _hoisted_7 = { class: "upgrade-module-version-value" }
const _hoisted_8 = {
  key: 0,
  class: "new-version-tag",
  color: "#F5222D"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "upgrade-module-branch-label" }, " 所属分支 ", -1)
const _hoisted_10 = { class: "upgrade-module-branch-value" }
const _hoisted_11 = { class: "upgrade-module-version-tools" }
const _hoisted_12 = { class: "upgrade-module-version-item-detail" }
const _hoisted_13 = { class: "upgrade-module-detail" }
const _hoisted_14 = {
  class: "upgrade-module-detail-item",
  label: "提交人"
}
const _hoisted_15 = {
  class: "upgrade-module-detail-item",
  label: "提交时间"
}
const _hoisted_16 = {
  class: "upgrade-module-detail-item",
  label: "版本状态",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_17 = {
  class: "upgrade-module-detail-item",
  label: "MD5"
}
const _hoisted_18 = {
  class: "upgrade-module-detail-item",
  label: "更新内容"
}
const _hoisted_19 = { class: "upgrade-module-version-item-tools" }
const _hoisted_20 = { class: "build-log-content" }
const _hoisted_21 = { style: {"display":"block","font-size":"22px","padding-bottom":"20px","text-align":"center"} }

import QRCode from '@/components/version-manage/component/QRCode.vue';
import { ProductDetailInfo, VersionItem } from '@/@types/version-manage/Product';
import { useProduct } from '@/modules/version-manage';
import { createVNode, inject, reactive, toRefs, h } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { downLoadFileByUrl } from '@/tools/common';
import { get, post } from '@/lib/api';
import { useVersionDetail } from '@/modules/version-manage/useVersionDetail';
import { showPVNotification } from '@/modules/version-manage/show-pv-notification';
import VersionDetailEditorModal from './VersionDetailEditorModal.vue';

interface IProps {
  /** 项目详情信息 */
  productDetailInfo: ProductDetailInfo;
  /** 版本列表 */
  versionList: VersionItem[];
  /** 仅显示正式（医疗器械要求） */
  onlyprod: boolean;
}

interface IEmit {
  (e: 'onVersionInfoUpdate'): void; // 版本信息更新成功
  (e: 'onLoading', value: boolean): void; // 正在请求
  (e: 'onStagedVersionPublished', value: { versionId: number; data: any }): void; // 预发布版本发布成功
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VersionUpgradeModule',
  props: {
    productDetailInfo: null,
    versionList: null,
    onlyprod: { type: Boolean }
  },
  emits: ["onVersionInfoUpdate", "onLoading", "onStagedVersionPublished"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onVersionInfoUpdate'): void; // 版本信息更新成功
  (e: 'onLoading', value: boolean): void; // 正在请求
  (e: 'onStagedVersionPublished', value: { versionId: number; data: any }): void; // 预发布版本发布成功
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** 项目详情信息 */
  productDetailInfo: ProductDetailInfo;
  /** 版本列表 */
  versionList: VersionItem[];
  /** 仅显示正式（医疗器械要求） */
  onlyprod: boolean;
};



const { productDetailInfo } = toRefs(props);
const productStore = useProduct();

/** 判断是否在编译中 */
const judgeIsProcessing = status => {
  return status === 'processing';
};
const qrCodeState = reactive({
  currentVersion: {} as VersionItem,
  visibleQRCode: false,
});

/** 构建日志 */
const buildingLogState = reactive({
  buildLog: '',
  visibleBuildLog: false,
});

const state = reactive({
  /** Jenkins构建进度 */
  buildPercent: 0,
  /** 重试的版本id */
  id: 0,
  /** 是否构建完成 */
  isBuildComplete: false,
  /** 任务启动时间 */
  timestamp: 0,
  /** 上次构建预估时间 */
  estimatedDuration: 0,
});

/** 发布环境 */
const environmentVersionStr = props.onlyprod
  ? [
      { code: 'production', txt: '正式版本' },
      { code: 'staging', txt: '预发布版本' },
    ]
  : [
      { code: 'production', txt: '正式版本' },
      { code: 'staging', txt: '预发布版本' },
      { code: 'test', txt: '测试版本' },
    ];

/** 根据环境获取项目迭代版本 */
const getVersionByEnvironment = (environment: string) => {
  if (!props.versionList?.length) return [];
  return props.versionList.filter(i => i.environment === environment);
};

const showQRCode = (versionInfo: VersionItem) => {
  qrCodeState.currentVersion = versionInfo;
  qrCodeState.visibleQRCode = true;
};

/** 获取状态值 */
const getState = (version: VersionItem) => {
  if (version.build === false) return 'build-fail';
  else if (version.publishState === 'timeout') return 'time-out';
  else if (version.publishState === 'silent_timeout') return 'silent-timeout';
  else if (!version.build) return 'building';
  else if (!version.enable) return 'not-enable';
  return version.publishState;
};

/** 构建重试 */
const buildRetry = id => {
  return new Promise(() => {
    get(`/system/program/ver/version/retry?id=${id}`).then(() => {
      message.info('重试构建中');
      state.id = id;
      emit('onVersionInfoUpdate');
      showPVNotification(
        {
          buildPercent: 0,
          id: state.id,
          isBuildComplete: false,
          timestamp: 0,
          estimatedDuration: 0,
        },
        {
          environmentText: '已发布到测试环境',
          emitCallback: () => emit('onVersionInfoUpdate'),
          closeText: '重新构建中',
        },
      );
    });
  });
};

/** 删除非正式版本 */
const removeVersion = (versionInfo: VersionItem) => {
  Modal.confirm({
    title: `警告`,
    icon: createVNode(ExclamationCircleOutlined),
    content: createVNode(
      'div',
      { style: 'color:red;' },
      `是否删除${productStore.environment[versionInfo.environment]}的${versionInfo.version}版本？`,
    ),
    onOk: () => {
      const hide = message.loading('版本删除中...');
      get(`/system/program/ver/version/remove?id=${versionInfo.id}`)
        .then(() => {
          emit('onVersionInfoUpdate');
          message.success('版本删除成功');
        })
        .finally(() => {
          hide();
        });
    },
  });
};

/** 获取高亮日志 */
const getBuildLogHighLight = (text: string) => {
  if (!text) return '';
  if (text.startsWith('Finished')) return 'log-highlight-green';
  if (/^[+]*\s*(export)?\s*\S+=\S+/.test(text)) return 'log-highlight-blue';
  if (/[╔║╚═]/.test(text)) return 'log-highlight-remark';
  return undefined;
};
/** 获取版本构建日志 */
const getVersionBuildLog = (versionId: number) => {
  return new Promise((resolve, reject) => {
    const hide = message.loading('获取版本日志中...');
    get('/system/program/ver/version/build/log', {
      versionId,
    })
      .then(d => {
        buildingLogState.buildLog = d;
        buildingLogState.visibleBuildLog = true;
        resolve(d);
      })
      .catch(err => {
        reject(err);
      })
      .finally(() => {
        hide();
      });
  });
};

/** 退回到上一版本 */
const undoVersion = (versionInfo: Record<string, any>) => {
  Modal.confirm({
    title: `警告`,
    icon: createVNode(ExclamationCircleOutlined),
    content: createVNode('div', { style: 'color:red;' }, `是否将${versionInfo.version}正式版本退回到上一版本？`),
    onOk: () => {
      const hide = message.loading('版本退回中...');
      get(`/system/program/ver/version/back?versionId=${versionInfo.id}`)
        .then(() => {
          emit('onVersionInfoUpdate');
          message.success('版本退回成功');
        })
        .finally(() => {
          hide();
        });
    },
  });
};

/** 发布预发布版本 */
const publishStagingVersion = (versionId: number) => {
  Modal.confirm({
    content: '是否发布到预发布环境？',
    icon: createVNode(ExclamationCircleOutlined),
    onOk: () => {
      emit('onLoading', true);
      const hide = message.loading('正在发布到预发布环境...');
      post('/system/program/ver/version/pre/release', {
        versionId,
      })
        .then(d => {
          emit('onVersionInfoUpdate');
          emit('onStagedVersionPublished', {
            versionId,
            data: d,
          });
        })
        .finally(() => {
          emit('onLoading', false);
          hide();
        });
    },
    okText: '确认发布',
    cancelText: '取消',
    onCancel() {
      Modal.destroyAll();
    },
  });
};

/** 点击子菜单 */
const handleMenuClick = ({ key }, versionInfo: VersionItem) => {
  switch (key) {
    case 'check':
      publishStagingVersion(versionInfo.id);
      break;
    case 'remove':
      removeVersion(versionInfo);
      break;
    case 'download':
      downLoadFileByUrl(versionInfo.storageKey);
      break;
    case 'buildlog':
      getVersionBuildLog(versionInfo.id);
      break;
    case 'undo':
      undoVersion(versionInfo);
      break;
    default:
      break;
  }
};

/** 发布正式版本 */
const publishProdVersion = (versionId: number) => {
  Modal.confirm({
    content: '是否发布到正式环境？',
    icon: createVNode(ExclamationCircleOutlined),
    onOk: () => {
      emit('onLoading', true);
      const hide = message.loading('正在发布到正式环境...');
      post('/system/program/ver/version/formal/release', {
        versionId,
      })
        .then(() => {
          message.success('已发布到正式环境');
          emit('onVersionInfoUpdate');
        })
        .finally(() => {
          emit('onLoading', false);
          hide();
        });
    },
    okText: '确认发布',
    cancelText: '取消',
    onCancel() {
      Modal.destroyAll();
    },
  });
};
const { versionDetailState, toogleVersionDetailModal, onVersionDetailChange, showAppVersionDetail, editAppVersionDetail } = inject(
  'useVersionDetail',
) as ReturnType<typeof useVersionDetail>;

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_qrcode_outlined = _resolveComponent("qrcode-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_redo_outlined = _resolveComponent("redo-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_cloud_download_outlined = _resolveComponent("cloud-download-outlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_code_outlined = _resolveComponent("code-outlined")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_undo_outlined = _resolveComponent("undo-outlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_ellipsis_outlined = _resolveComponent("ellipsis-outlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_file_search_outlined = _resolveComponent("file-search-outlined")!
  const _component_delete_outlined = _resolveComponent("delete-outlined")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(environmentVersionStr), (environment) => {
      return (_openBlock(), _createElementBlock("div", {
        key: environment.code,
        class: "upgrade-module-environment"
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(environment.txt), 1),
        _createElementVNode("div", _hoisted_3, [
          (!getVersionByEnvironment(environment.code).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_a_empty, {
                  image: _unref(productStore).simpleImage,
                  description: `未提交${environment.txt}`
                }, null, 8, ["image", "description"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVersionByEnvironment(environment.code), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "upgrade-module-version-item"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(item.version) + " ", 1),
                  (
                  item.environment === 'production' &&
                  _unref(productDetailInfo)?.productVersionVoList?.find?.(i => i.branchId == item.branchId && i.version === item.version) &&
                  index === _unref(productDetailInfo)?.productVersionVoList.length - 1
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, " new "))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.programVerProductBranch.branchName), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_tag, {
                    color: "blue",
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (showQRCode(item))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_qrcode_outlined)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("二维码")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, _toDisplayString(item.createBy), 1),
                  _createElementVNode("li", _hoisted_15, _toDisplayString(item.createTime || '——'), 1),
                  _createElementVNode("li", _hoisted_16, [
                    _createVNode(_component_a_badge, {
                      status: _unref(productStore).versionState[getState(item)].status,
                      text: _unref(productStore).versionState[getState(item)].text
                    }, null, 8, ["status", "text"]),
                    _createVNode(_component_a_tooltip, null, {
                      title: _withCtx(() => [
                        _createTextVNode("构建重试")
                      ]),
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, { type: "link" }, {
                          default: _withCtx(() => [
                            (item.build === false && item.environment !== 'production')
                              ? (_openBlock(), _createBlock(_component_redo_outlined, {
                                  key: 0,
                                  onClick: ($event: any) => (buildRetry(item.id))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)), [
                          [_directive_hasPermi, ['system:version:retry']]
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("li", _hoisted_17, _toDisplayString(item.md5 || '——'), 1),
                  _createElementVNode("li", _hoisted_18, [
                    _createElementVNode("pre", null, _toDisplayString(item.updateContent), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  style: {"vertical-align":"bottom","margin-right":"10px"},
                  onClick: ($event: any) => (_unref(showAppVersionDetail)(item.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查看软件信息 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  style: {"vertical-align":"bottom","margin-right":"10px"},
                  onClick: ($event: any) => (_unref(editAppVersionDetail)(item.versionData, item.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 编辑软件信息 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_hasPermi, ['system:project:edit']]
                ]),
                (environment.code == 'production')
                  ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                      overlay: _withCtx(() => [
                        _createVNode(_component_a_menu, {
                          "force-sub-menu-render": true,
                          onClick: ($event: any) => (handleMenuClick($event, item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_item, { key: "download" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_cloud_download_outlined)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" 下载包 ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_menu_item, { key: "buildlog" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_code_outlined)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" 查看构建日志 ")
                              ]),
                              _: 1
                            }),
                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                              _createVNode(_component_a_menu_divider),
                              _createVNode(_component_a_menu_item, {
                                key: "undo",
                                style: {"color":"#f5222d"}
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_undo_outlined)
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" 版本回退 ")
                                ]),
                                _: 1
                              })
                            ])), [
                              [_directive_hasPermi, ['system:version:back']]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { type: "primary" }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_ellipsis_outlined)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024))
                  : (environment.code == 'staging')
                    ? (_openBlock(), _createBlock(_component_a_dropdown, {
                        key: 1,
                        type: "primary"
                      }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, {
                            "force-sub-menu-render": true,
                            onClick: ($event: any) => (handleMenuClick($event, item))
                          }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                _createVNode(_component_a_menu_item, {
                                  key: "detail",
                                  onClick: ($event: any) => (publishProdVersion(item.id))
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_file_search_outlined)
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" 正式发布 ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])), [
                                [_directive_hasPermi, ['system:version:formal:release']]
                              ]),
                              _createVNode(_component_a_menu_item, { key: "buildlog" }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_code_outlined)
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode(" 查看构建日志 ")
                                ]),
                                _: 1
                              }),
                              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                _createVNode(_component_a_menu_divider),
                                _createVNode(_component_a_menu_item, {
                                  key: "remove",
                                  style: {"color":"#f5222d"},
                                  disabled: judgeIsProcessing(_unref(productStore).versionState[getState(item)].status)
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_delete_outlined)
                                  ]),
                                  default: _withCtx(() => [
                                    _createTextVNode(" 删除 ")
                                  ]),
                                  _: 2
                                }, 1032, ["disabled"])
                              ])), [
                                [_directive_hasPermi, ['system:version:remove']]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_ellipsis_outlined)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024))
                    : (environment.code == 'test')
                      ? (_openBlock(), _createBlock(_component_a_dropdown, {
                          key: 2,
                          type: "primary"
                        }, {
                          overlay: _withCtx(() => [
                            (__props.onlyprod)
                              ? (_openBlock(), _createBlock(_component_a_menu, {
                                  key: 0,
                                  "force-sub-menu-render": true,
                                  onClick: ($event: any) => (handleMenuClick($event, item))
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                      _createVNode(_component_a_menu_item, { key: "check" }, {
                                        icon: _withCtx(() => [
                                          _createVNode(_component_file_search_outlined)
                                        ]),
                                        default: _withCtx(() => [
                                          _createTextVNode(" 确认 ")
                                        ]),
                                        _: 1
                                      })
                                    ])), [
                                      [_directive_hasPermi, ['system:version:pre:release']]
                                    ]),
                                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                      _createVNode(_component_a_menu_item, { key: "undo" }, {
                                        icon: _withCtx(() => [
                                          _createVNode(_component_delete_outlined)
                                        ]),
                                        default: _withCtx(() => [
                                          _createTextVNode(" 退回 ")
                                        ]),
                                        _: 1
                                      })
                                    ])), [
                                      [_directive_hasPermi, ['system:version:pre:release']]
                                    ]),
                                    _createVNode(_component_a_menu_item, { key: "buildlog" }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_component_code_outlined)
                                      ]),
                                      default: _withCtx(() => [
                                        _createTextVNode(" 查看构建日志 ")
                                      ]),
                                      _: 1
                                    }),
                                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                      _createVNode(_component_a_menu_divider),
                                      _createVNode(_component_a_menu_item, {
                                        key: "remove",
                                        style: {"color":"#f5222d"},
                                        disabled: judgeIsProcessing(_unref(productStore).versionState[getState(item)].status)
                                      }, {
                                        icon: _withCtx(() => [
                                          _createVNode(_component_delete_outlined)
                                        ]),
                                        default: _withCtx(() => [
                                          _createTextVNode(" 删除 ")
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled"])
                                    ])), [
                                      [_directive_hasPermi, ['system:version:remove']]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_a_menu, {
                                  key: 1,
                                  "force-sub-menu-render": true,
                                  onClick: ($event: any) => (handleMenuClick($event, item))
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                      _createVNode(_component_a_menu_item, {
                                        key: "detail",
                                        onClick: ($event: any) => (publishStagingVersion(item.id))
                                      }, {
                                        icon: _withCtx(() => [
                                          _createVNode(_component_file_search_outlined)
                                        ]),
                                        default: _withCtx(() => [
                                          _createTextVNode(" 提交测试 ")
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])), [
                                      [_directive_hasPermi, ['system:version:pre:release']]
                                    ]),
                                    _createVNode(_component_a_menu_item, { key: "buildlog" }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_component_code_outlined)
                                      ]),
                                      default: _withCtx(() => [
                                        _createTextVNode(" 查看构建日志 ")
                                      ]),
                                      _: 1
                                    }),
                                    _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                      _createVNode(_component_a_menu_divider),
                                      _createVNode(_component_a_menu_item, {
                                        key: "remove",
                                        style: {"color":"#f5222d"},
                                        disabled: judgeIsProcessing(_unref(productStore).versionState[getState(item)].status)
                                      }, {
                                        icon: _withCtx(() => [
                                          _createVNode(_component_delete_outlined)
                                        ]),
                                        default: _withCtx(() => [
                                          _createTextVNode(" 删除 ")
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled"])
                                    ])), [
                                      [_directive_hasPermi, ['system:version:remove']]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { type: "primary" }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_ellipsis_outlined)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]))
    }), 128)),
    _createVNode(_component_a_drawer, {
      visible: buildingLogState.visibleBuildLog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((buildingLogState.visibleBuildLog) = $event)),
      width: "800px",
      title: `构建日志`,
      placement: "right",
      "body-style": { padding: '0px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("ol", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildingLogState.buildLog.replace(/\r/g, '\n').split('\n'), (row, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `log-${index}`,
              class: _normalizeClass(getBuildLogHighLight(row))
            }, _toDisplayString(row), 3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: qrCodeState.visibleQRCode,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((qrCodeState.visibleQRCode) = $event)),
      "body-style": { padding: '0px' },
      footer: null,
      width: 300,
      title: "二维码"
    }, {
      default: _withCtx(() => [
        _createVNode(QRCode, {
          width: 300,
          height: 300,
          margin: 0,
          value: qrCodeState.currentVersion.storageKey
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_21, "v" + _toDisplayString(qrCodeState.currentVersion.version), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(VersionDetailEditorModal, {
      "version-data": _unref(versionDetailState).currentVersionData,
      visible: _unref(versionDetailState).VersionDetailmodalVisible,
      "project-id": _unref(productDetailInfo).id,
      onOnCancel: _unref(toogleVersionDetailModal),
      onOnSubmit: _unref(onVersionDetailChange)
    }, null, 8, ["version-data", "visible", "project-id", "onOnCancel", "onOnSubmit"])
  ]))
}
}

})